import React, { useState } from "react";
import EmailOtp from "./EmailOtp";
import { Steps } from "primereact/steps";
import DriverInformation from "./DriverInformation";
import EmergencyContact from "./EmergencyContact";
import Questionnaire from "./Questionnaire";
import Policies from "./Policies";
import EmploymentHistory from "./EmploymentHistory";

export default function ApplyJob() {
  const [step, setStep] = useState(null);
  const items = [
    {
      label: "Driver Details",
    },
    {
      label: "Employment History",
    },
    {
      label: "Emergency Contact",
    },
    {
      label: "Questionnaire",
    },
    {
      label: "Agreement Policies",
    },
  ];

  console.log("step", step);
  return (
    <>
      {step === null ? (
        <EmailOtp step={step} setStep={setStep} />
      ) : (
        <>
          <h3 className="text-center">Application Form</h3>
          <Steps model={items} activeIndex={step} />
          {step === 0 ? (
            <DriverInformation step={step} setStep={setStep} />
          ) : step === 1 ? (
            <EmploymentHistory step={step} setStep={setStep} />
          ) : step === 2 ? (
            <EmergencyContact step={step} setStep={setStep} />
          ) : step === 3 ? (
            <Questionnaire step={step} setStep={setStep} />
          ) : (
            <Policies step={step} setStep={setStep} />
          )}
        </>
      )}
    </>
  );
}
